$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
View = require 'view'

module.exports = class BaseCalendarView extends View
  initialize: ->
    @$reactRoot ?= $('<div></div>')

  renderContent: ->
    throw new Error('BaseCalendarView renderContent method is not defined.')

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @renderContent()

  remove: ->
    if @$reactRoot
      ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super

  render: ->
    @$el.append(@$reactRoot)
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])
    @



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/base-calendar-view.coffee